import React from 'react';
import {
  CustomizedButton,
  CustomizedDialog,
  CustomizedTypography
} from '@components/Customized';
import { Warning } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';

interface Props {
  matches: boolean;
  open: boolean;
  onClose: () => void;
  onWithdraw: () => void;
}

const WithdrawalConfirmDialog = ({
  matches,
  open,
  onClose,
  onWithdraw
}: Props) => {
  const classes = useStyels();
  return (
    <CustomizedDialog
      color="error"
      title="탈퇴 확인"
      icon={<Warning />}
      open={open}
      onClose={onClose}
    >
      <CustomizedTypography
        color="textPrimary"
        variant={matches ? 'body1' : `h4`}
        fontWeight="500"
        gutterBottoms={12}
      >
        탈퇴를 완료하면 모든 서비스 이용 기록이 삭제되며 이후 복구할 수
        없습니다.
      </CustomizedTypography>
      <CustomizedTypography
        color="textSecondary"
        variant={matches ? 'body2' : `body1`}
        fontWeight="500"
        gutterBottoms={matches ? 24 : 32}
      >
        탈퇴를 진행하시겠습니까?
      </CustomizedTypography>

      <div className={classes['bottomCTA']}>
        <CustomizedButton
          fullWidth
          variant="contained"
          color="error"
          size={matches ? 'medium' : 'large'}
          onClick={onWithdraw}
        >
          탈퇴 진행하기
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          variant="contained"
          color="default"
          size={matches ? 'medium' : 'large'}
          onClick={onClose}
        >
          취소
        </CustomizedButton>
      </div>
    </CustomizedDialog>
  );
};

export default WithdrawalConfirmDialog;

const useStyels = makeStyles((theme) => ({
  bottomCTA: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    '& > :first-child': {
      marginRight: 8
    }
  }
}));
